import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";

export default function ProductCard({ product }) {
  const { lang, t } = useLang();
  const name = lang === "ar" ? product.name_ar : product.name_en;
  const hasOffer = !!product.offer && product.offer > 0;

  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="product-card group block"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#F3F0EB] rounded-md">
        <img
          src={product.image}
          alt={name}
          loading="lazy"
          className="product-card-img absolute inset-0 h-full w-full object-cover"
        />
        {hasOffer && (
          <span className="absolute top-3 start-3 bg-[#7B5CBF] text-white text-[10px] tracking-wider px-2 py-1 rounded-full uppercase">
            -{Math.round(product.offer)}%
          </span>
        )}
        {product.featured && !hasOffer && (
          <span className="absolute top-3 start-3 bg-[#1A1738] text-white text-[10px] tracking-wider px-2 py-1 rounded-full uppercase">
            {t("featured")}
          </span>
        )}
      </div>
      <div className="pt-4">
        <div className="text-[10px] uppercase tracking-[0.18em] text-[#7B5CBF]">
          {product.brand}
        </div>
        <div className="mt-1 font-display text-base leading-snug text-[#1A1738] line-clamp-2 min-h-[2.75rem]">
          {name}
        </div>
        <div className="mt-2 flex items-baseline gap-2">
          {hasOffer ? (
            <>
              <span className="text-[#1A1738] font-medium">${product.final_price.toFixed(2)}</span>
              <span className="text-[#767676] text-sm line-through">${product.price.toFixed(2)}</span>
            </>
          ) : (
            <span className="text-[#1A1738] font-medium">${product.price.toFixed(2)}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
